webpackJsonp([104],{

/***/ 3120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dataModel: {
        name: '',
        business_type_id: '',
        status: 1
      },
      businessTypeOptions: [],
      btLoading: false,
      formRules: {
        name: [{ required: true, message: '请输入工种名称', trigger: 'blur' }, { max: 200, message: '工种名称长度不能超过200个字符', trigger: 'blur' }],
        business_type_id: [{ required: true, message: '请选择所属行业', trigger: 'change' }],
        status: [{ required: true, type: 'number', message: '请选择状态', trigger: 'change' }]
      }
    };
  },


  computed: {
    id: function id() {
      return this.$route.params.id;
    }
  },

  created: function created() {
    if (this.id) {
      this.loadData();
    }
  },


  methods: {
    loadData: function loadData() {
      var _this = this;

      request.page('workInfoWorkTypeGet', this.id).then(function (_ref) {
        var data = _ref.data;

        _this.dataModel = {
          name: data.name || '',
          business_type_id: data.business_type_id || '',
          status: data.status !== undefined ? data.status : 1
        };
        if (data.business_type_id) {
          _this.findBusinessType({ id: data.business_type_id }).then(function (res) {
            var item = res.data || res;
            if (item && item.id) {
              var exists = _this.businessTypeOptions.find(function (b) {
                return b.id === item.id;
              });
              if (!exists) {
                _this.businessTypeOptions.unshift(item);
              }
            }
          }).catch(function () {});
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return false;
        }

        var api = _this2.id ? 'workInfoWorkTypeEdit' : 'workInfoWorkTypeCreate';
        var params = _this2.id ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ id: _this2.id }, _this2.dataModel) : _this2.dataModel;

        request.common(api, params).then(function (_ref2) {
          var data = _ref2.data;

          _this2.$message({
            showClose: true,
            message: _this2.id ? '修改成功' : '添加成功',
            type: 'success'
          });
          _this2.$router.push({ name: '职业信息工种' });
        });
      });
    },
    queryBusinessType: function queryBusinessType() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var keyword = params.keyword || params.name || '';
      return request.page('workInfoBusinessTypeQuery', {
        name: keyword,
        per_page: 20,
        current_page: 1
      });
    },
    findBusinessType: function findBusinessType(_ref3) {
      var id = _ref3.id;

      return request.page('workInfoBusinessTypeGet', id);
    }
  }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkInfoWorkTypeForm_vue__ = __webpack_require__(3120);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3fa60e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkInfoWorkTypeForm_vue__ = __webpack_require__(5882);
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WorkInfoWorkTypeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f3fa60e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WorkInfoWorkTypeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 5882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ path: '/work-info-work-type/table' }}},[_vm._v("职业信息工种")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.dataModel,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"prop":"name","label":"名称"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入工种名称"},model:{value:(_vm.dataModel.name),callback:function ($$v) {_vm.$set(_vm.dataModel, "name", $$v)},expression:"dataModel.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"business_type_id","label":"所属行业"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","filterable":"","id-key":"id","label-key":"name","value-key":"id","placeholder":"输入行业名称搜索","disabled":!!_vm.id,"query-request":_vm.queryBusinessType,"find-request":_vm.findBusinessType},model:{value:(_vm.dataModel.business_type_id),callback:function ($$v) {_vm.$set(_vm.dataModel, "business_type_id", $$v)},expression:"dataModel.business_type_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"status","label":"状态"}},[_c('el-radio-group',{model:{value:(_vm.dataModel.status),callback:function ($$v) {_vm.$set(_vm.dataModel, "status", $$v)},expression:"dataModel.status"}},[_c('el-radio',{attrs:{"label":1}},[_vm._v("启用")]),_vm._v(" "),_c('el-radio',{attrs:{"label":0}},[_vm._v("禁用")])],1)],1)],1)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-check","native-type":"submit"}},[_vm._v("保存\n        ")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-back"},on:{"click":function($event){return _vm.$router.push({name: '职业信息工种'})}}},[_vm._v("取消\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/WorkInfoWorkTypeForm.4e740c08dcd10a7cfbdb.js